const Characteristic = () => import('Views/characteristic/index');
const Zhongchiduwo = () => import('Views/characteristic/zhongchiduwo-new-ui');
const Zhujiangkou = () => import('Views/characteristic/zhujiangkou-new-ui');
const Xishadixiashui = () => import('Views/characteristic/xishadixiashui-new-ui');

export default[
  { path: '/characteristic', component: Characteristic },
  { path: '/characteristic/zhongchiduwo', component: Zhongchiduwo },
  { path: '/characteristic/zhujiangkou', component: Zhujiangkou },
  { path: '/characteristic/xishadixiashui', component: Xishadixiashui },
];



// WEBPACK FOOTER //
// ./src/router/characteristic.js